import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { Locale, getSprdLocale } from '@/utility/locale';
import { get } from '@/utility/requestHelpers/clientRequestHelpers';
export const productTypeQueryOptions = (shopId: string | number, productTypeId: string | number, locale: Locale) => ({
  queryKey: ['productType', String(shopId), String(productTypeId), locale],
  queryFn: async () => {
    return await get<ProductType>(`/api/v1/shops/${shopId}/productTypes/${productTypeId}?locale=${getSprdLocale(locale)}&apiKey=mp-next`);
  },
  staleTime: 60 * 60 * 1000,
  // 1 hour
  retry: 1
});
const useProductType = (shopId, productTypeId, locale) => {
  const $ = _c(4);
  let t0;
  if ($[0] !== locale || $[1] !== productTypeId || $[2] !== shopId) {
    t0 = productTypeQueryOptions(shopId, productTypeId, locale);
    $[0] = locale;
    $[1] = productTypeId;
    $[2] = shopId;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return useQuery(t0);
};
export default useProductType;